import { InsightsActionsResponse } from '../api/types';
import { generateGUID } from './guid.helper';

export type DiscoverChatData = {
	insights: InsightsActionsResponse;
	questionText: string;
};

const store = new Map<string, DiscoverChatData>();

export const storeDiscoverChat = (data: DiscoverChatData): string => {
	const nonce = generateGUID();
	store.set(nonce, data);

	// Auto-cleanup after 30 seconds
	setTimeout(() => {
		store.delete(nonce);
	}, 30_000);

	return nonce;
};

export const consumeDiscoverChat = (nonce: string): DiscoverChatData | undefined => {
	const data = store.get(nonce);
	if (data) {
		store.delete(nonce);
	}
	return data;
};
